import { useNavigate, useLocation } from 'react-router-dom';
import { useLang } from '../lib/lang';
import { Card, CardContent } from '../components/ui/card';
import { PasswordlessLoginForm } from '../components/PasswordlessLogin';
import { Info } from 'lucide-react';

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  useLang();
  const from = location.state?.from || '/account';
  const flashMessage = location.state?.message;

  return (
    <div className="min-h-[85vh] flex items-center justify-center px-4 py-8">
      <Card className="w-full max-w-md bg-white border-2 border-[hsl(var(--gold)/0.3)] shadow-[0_20px_60px_rgba(20,22,26,0.10)] overflow-hidden">
        {flashMessage && (
          <div className="px-5 py-3 bg-gradient-to-r from-[#FEF3C7] to-[#FDE68A] border-b border-amber-300 flex items-start gap-2 text-sm text-amber-900" data-testid="flash-message">
            <Info className="w-4 h-4 mt-0.5 shrink-0" />
            <span className="leading-snug font-medium">{flashMessage}</span>
          </div>
        )}
        <CardContent className="p-6">
          <PasswordlessLoginForm onSuccess={() => navigate(from)} />
        </CardContent>
      </Card>
    </div>
  );
}
